import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=4621135c"
import script from "./Offline.vue?vue&type=script&lang=ts"
export * from "./Offline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports